import { render } from "./changebrith.vue?vue&type=template&id=22df6818&scoped=true"
import script from "./changebrith.vue?vue&type=script&lang=js"
export * from "./changebrith.vue?vue&type=script&lang=js"

import "./changebrith.vue?vue&type=style&index=0&id=22df6818&lang=scss&scoped=true"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22df6818"]])

export default __exports__